import {
  ServiceTypeFormDefaultValues,
  ServiceTypeFormProps,
  ServiceTypeFormRawValues,
  ServiceTypeFormType
} from "./ServiceTypeForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {ServiceTypeEntity} from "@ots-frontend/ots-data";

export const toFormDefaultsFromServiceType = (serviceType: ServiceTypeEntity | undefined): ServiceTypeFormDefaultValues => {
  return {
    type: serviceType?.name,
    abbr: serviceType?.abbr,
    doNotUse: serviceType?.doNotUse,
  };
};

const getInitialValues = (defaultValues: ServiceTypeFormDefaultValues | undefined): ServiceTypeFormRawValues => {
  return {
    type: defaultValues?.type,
    abbr: defaultValues?.abbr,
    doNotUse: defaultValues?.doNotUse,
  }
}

export type UseServiceTypeFormProps = Pick<ServiceTypeFormProps, 'defaultValues'> & {}

export function useServiceTypeForm(props: UseServiceTypeFormProps): ServiceTypeFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      type: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
